import { HttpEventType } from '@angular/common/http';
import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { SubrentalEntryImportModel } from 'src/app/models/imports/subrental-entry-import.model';
import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { SubrentalEntryDetailService } from 'src/app/services/subrental/subrental-entry-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-subrental-entry',
  templateUrl: './import-subrental-entry.component.html',
  styleUrls: ['./import-subrental-entry.component.scss'],
  standalone: false
})
export class ImportSubrentalEntryComponent implements OnInit {

  branchName: string = "";
  eventFile: any;
  errorSubrentalEntry: number = 0;
  inputs$: BehaviorSubject<any>;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  output$: Subject<any>;
  subscription: Subscription;
  subrentalEntryAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  subrentalEntryModel: InventoryEntryModel = new InventoryEntryModel();
  visibleTxt: boolean = false;

  constructor(public config: DynamicDialogConfig,
    private subrentalEntryDetailService: SubrentalEntryDetailService,
    @Optional() private ref: DynamicDialogRef,
    private toastHandlerService: ToastHandlerService) {
  }

  ngOnInit() {
    const inputs$ = this.config.data?.inputs$;
    if (!inputs$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = inputs$?.subscribe((inputs: any) => {
      this.subrentalEntryModel = inputs.subrentalEntryModel ?? [];
      this.branchName = inputs.nameBranch
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.subrentalEntryAlerts || this.subrentalEntryAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.subrentalEntryDetailService.exportImportErrors(this.subrentalEntryAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionEntradasSubalquiler_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  async downloadGuideImport() {
    this.subrentalEntryDetailService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response:
          {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = "GuiaEntradasSubalquiler.docx";
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importSubrentalEntry() {
    this.subrentalEntryAlerts = [];
    this.errorSubrentalEntry = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<SubrentalEntryImportModel>();
    let row: SubrentalEntryImportModel;
    let storeCode: number, articleCode: number, articleName: string, quantity: number, unitValue: number, counter: number = 1;
    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('error', 'El archivo ingresado no tiene registros para importar.', '');
          return;
        }
        rows.splice(0, 1);
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;
          storeCode = parseFloat(element[0] as string);
          articleCode = parseFloat(element[1] as string);
          articleName = element[2] as string;
          quantity = parseFloat(element[3] as string);
          unitValue = parseFloat(element[4] as string);

          // A. Bodega
          if (isNaN(storeCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El codigo de la bodega no es válido.`;
            this.subrentalEntryAlerts.push(alert);
            rowHasError = true;
          }
          //B. Artículo
          if (isNaN(articleCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El codigo del artículo no es válido.`;
            this.subrentalEntryAlerts.push(alert);
            rowHasError = true;
          }
          // C. Nombre artículo (No es necesario validar)
          // D. Cantidad
          if (isNaN(quantity) || quantity <= 0) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
            this.subrentalEntryAlerts.push(alert);
            rowHasError = true;
          }
          // E. Valor Unitario
          if (isNaN(unitValue) || unitValue < 0) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. El vr.unitario no es válida.`;
            this.subrentalEntryAlerts.push(alert);
            rowHasError = true;
          }

          if (!rowHasError) {
            row = new SubrentalEntryImportModel(counter, this.subrentalEntryModel.inventoryEntryId, storeCode, articleCode, articleName, quantity, unitValue);
            rowsImports.push(row);
          } else {
            isOk = false;
          }

        });
        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.subrentalEntryDetailService.importSubrentalEntry(rowsImports));
            this.loadPreInvoicingModel = response;
            this.subrentalEntryAlerts = response?.alerts ?? [];
            this.errorSubrentalEntry = response?.preInvoicingStateId;
            if (this.errorSubrentalEntry === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR');
            } else if (this.subrentalEntryAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
            }
            else {
              const output$ = this.config.data?.output$;
              output$?.next({ type: 'updateList', payload: true });
              this.toastHandlerService.showToast('success', 'La importación terminó exitosamente.', '');
            }
          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error en la importación de entrada de subalquiler.', error);
          }

          (<HTMLInputElement>document.getElementById('fileImport')).value = '';
        } else {
          this.errorSubrentalEntry = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.', '');
    }
  }
}
